import type { AxiosInstance } from 'axios';
import type { ApiResponseType, SecureAuthData, SecureAuthRequest } from '~/service/api/types';

export default (axiosInstance: AxiosInstance) => ({

    /**
   * @description login user via eth wallet
   *
   * @tags secure
   * @name login
   * @request POST:/login
   * @response `200` `ApiResponseType<SecureAuthData>` login user
   * @response `default` `ApiEmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any content answers
   */
    async login(body: SecureAuthRequest) {
        const res = await axiosInstance.post<ApiResponseType<SecureAuthData>>('/v1/login', body);
        return res.data;
    },

    /**
   * @description refresh access token
   *
   * @tags secure
   * @name refresh
   * @request POST:/refresh
   * @response `200` `ApiResponseType<SecureAuthData>` get new pair of access/refresh tokens
   * @response `default` `ApiEmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any content answers
   */
    async refresh(refreshToken: string) {
        const res = await axiosInstance.post<ApiResponseType<SecureAuthData>>('/v1/refresh', { refreshToken });
        return res.data;
    }
} as const);
